<template>
    <v-container class="mt-4 pa-0">
        <v-flex>
            <v-card color="primary" class="elevation-1" :style="{ textAlign: 'center' }" v-if="!!repair.length">
                
                <!-- TOOLBAR -->

                <v-toolbar color="primary" flat>
                    <v-tooltip bottom>
                        <v-toolbar-side-icon slot="activator" @click="reset()" icon>
                            <v-icon>arrow_back</v-icon>
                        </v-toolbar-side-icon>
                        <span>Return to Barcode</span>
                    </v-tooltip>
                    <h2>
                        <span class="hidden-xs-only">Repair Reference -</span>

                        <a target="new"
                            :href="`https://ops.bohmtech.com/web#id=${repair[0].id}&view_type=form&model=mrp.repair`"
                            :style="{ color: '#F04E23', textDecoration: 'none' }" class="ml-2">{{ repair[0].name }}</a>
                        <span class="hidden-xs-only" v-if="repair[0].partner_id"> - {{ repair[0].partner_id[1] }}</span>
                    </h2>

                    <v-spacer></v-spacer>

                    <h3 class="hidden-xs-only">{{ repair[0].product_id[1] }}</h3>
                </v-toolbar>

                <!-- NOT TESTED -->

                
                
                <div v-if="!hasBeenTested">
                    <v-card color="primary" class="mb-5 elevation-0" :style="{ textAlign: 'center' }">
                        <h2 class="mt-2">This watch has not been tested!</h2>
                        <v-btn color="primary" @click="reset()">Go Home</v-btn>
                    </v-card>
                </div>

                <!-- FINISHED REPAIR -->

                <div v-else-if="repairState === 'done'">
                    <v-card color="primary" class="mb-5 elevation-0" :style="{ textAlign: 'center' }">
                        <h2 class="mt-2">This repair order has been completed!</h2>
                        
                        <v-card height="550px" class="mt-3" color="primary" flat>
                            <span class="mb-2">Product: {{ repair[0].x_finished_product[1] }}</span>
                            <v-layout row wrap>
                            <v-flex xs6>
                            <v-select :items="['medium', 'small']" v-model="selectedSize" color="secondary"
                                    label="Select Label Size" box :style="{ width: '50%', margin: 'auto' }"></v-select>
                            <v-select :items="allPrinters" v-model="selectedPrinter" color="secondary"
                                label="Select Printer" box :style="{ width: '50%', margin: 'auto' }"></v-select>
                            <v-btn color="secondary" @click="printLabel()">Print Label</v-btn>
                            </v-flex>

                            <v-flex xs6>
                                <v-select :items="['medium', 'small']" v-model="selectedSizeTwo" color="secondary"
                                        label="Select Label Size" box :style="{ width: '50%', margin: 'auto' }"></v-select>
                                <v-select :items="allPrinters" v-model="selectedPrinterTwo" color="secondary"
                                    label="Select Printer" box :style="{ width: '50%', margin: 'auto' }"></v-select>
                                <v-btn color="secondary" @click="printLabel(true)">Print Label</v-btn>
                            </v-flex>
                            </v-layout> 
                            <v-btn color="primary" @click="reset()">Go Home</v-btn>
                            <v-btn color="primary" @click="openGradeHistory()">View Grades</v-btn>
                        </v-card>
                    </v-card>
                </div>
                
                <!-- Victra -->
                <div v-else-if="repairState === 'draft' && partner == OWNER.VICTRA">
                    <v-card color="primary" class="mb-5 elevation-0" :style="{ textAlign: 'center' }">
                        <v-card height="700px" class="mt-2" color="primary" flat>
                            <h2 class="my-2">Select A Grade</h2>
                            <v-select :items="repair[0].x_mrp_passed !== 'FAILED' ? ['Certified Refurbished', 'Refurbished', 'Pre-Owned', 'Used', 'W. Used', 'W. Failed'] : ['W. Used', 'W. Failed']"
                                    v-model="condition" color="secondary" label="Select Condition" box
                                    :style="{ width: '50%', margin: 'auto' }"></v-select>
                            <v-btn v-if="condition" color="success" @click="completeHybrid('rev')">Submit Grade</v-btn>

                            <v-layout style="width: 500px; margin: auto" class="mt-5">
                                <v-text-field
                                    v-model="model"
                                    label="Model #"
                                    color="secondary"
                                    box
                                ></v-text-field>
                                <v-btn color="secondary" class="mt-2" @click="updateModel" >Update</v-btn>
                            </v-layout>
                        </v-card>
                    </v-card>
                </div>

                <!-- Bohm -->

                <div v-else-if="repairState === 'draft' && (repair[0].partner_id[0] == 1 || repair[0].partner_id[0] == OWNER.VERIZON)">
                    <v-card color="primary" class="mb-5 elevation-0" :style="{ textAlign: 'center' }">
                        <v-card height="700px" class="mt-2" color="primary" flat>
                            <h2 class="my-2">Select A Grade</h2>
                            <v-select :items="repair[0].x_mrp_passed !== 'FAILED' ? ['Certified Refurbished', 'Refurbished', 'Pre-Owned', 'Used', 'W. Used', 'W. Failed'] : ['W. Used', 'W. Failed']"
                                    v-model="condition" color="secondary" label="Select Condition" box
                                    :style="{ width: '50%', margin: 'auto' }"></v-select>
                            <v-select v-show="repair[0].product_id[0] == 112384 && ['W. Used', 'W. Failed'].includes(condition)" :items="duplicateProducts" v-model="duplicateProduct" color="secondary"
                                    label="Select Product" box :style="{ width: '50%', margin: 'auto' }"></v-select>
                            <v-btn v-if="condition" color="success" @click="completeHybrid('rev')">Submit Grade</v-btn>

                            <v-layout style="width: 500px; margin: auto" class="mt-5">
                                <v-text-field
                                    v-model="model"
                                    label="Model #"
                                    color="secondary"
                                    box
                                ></v-text-field>
                                <v-btn color="secondary" class="mt-2" @click="updateModel" >Update</v-btn>
                            </v-layout>
                        </v-card>
                    </v-card>
                </div>

                <!-- Verizon Services -->

                <div v-else-if="repairState === 'draft' && repair[0].partner_id[0] == OWNER.VERIZON && !servicesView && !revshareView && !asurionView">
                    <v-card color="primary" class="mb-5 elevation-0" :style="{ textAlign: 'center' }">
                        <v-card height="700px" class="mt-2" color="primary" flat>
                            <img 
                                style="width: 240px; margin: 36px auto; display: block;"
                                src="@/../public/img/verizon.svg"
                            />
                            <v-btn @click="handleVZview('services')">Service</v-btn>
                            
                            <img
                                style="width: 240px; margin: 36px auto; display: block;"
                                src="@/../public/img/bohm.svg"
                            />
                            <v-btn @click="handleVZview('revshare')">Rev Share</v-btn>
                            
                            <img 
                                :style="{width: '240px', margin: '36px auto', display: 'block'}"
                                src="@/../public/img/asurion.svg"
                            />
                            <v-btn  @click="handleVZview('asurion')">Asurion</v-btn>
                            <v-layout style="width: 500px; margin: auto" class="mt-5">
                                <v-text-field
                                    v-model="model"
                                    label="Model #"
                                    color="secondary"
                                    box
                                ></v-text-field>
                                <v-btn color="secondary" class="mt-2" @click="updateModel" >Update</v-btn>
                            </v-layout>
                        </v-card>
                    </v-card>
                </div>


                <div v-else-if="repair[0].partner_id[0] == OWNER.VERIZON && (servicesView || revshareView || asurionView)">
                    <v-card color="primary" class="mb-5 elevation-0" :style="{ textAlign: 'center' }">
                        <v-card height="700px" class="mt-2" color="primary" flat>
                            <div v-if="servicesView">
                                <h2 class="my-2">Services - Select A Grade</h2>
                                <v-select color="secondary" :items="[
                                        {text: 'DPA', value: 'A'},
                                        {text: 'DPB', value: 'B'}
                                    ]" item-text="text"
                                    return-object v-model="asnGrade" label="Select A Grade"
                                    box :style="{ width: '50%', margin: 'auto' }"></v-select>
                                <v-btn color="success" @click="completeHybrid('vz')">Submit Grade</v-btn>
                            </div>

                            <div v-if="revshareView">
                                <h2 class="my-2">Select a Condition</h2>
                                <v-select :items="['Certified Refurbished', 'Refurbished', 'Pre-Owned', 'Used', 'W. Used', 'W. Failed']"
                                    v-model="condition" color="secondary" label="Select Condition" box
                                    :style="{ width: '50%', margin: 'auto' }"></v-select>
                                <v-select v-show="repair[0].product_id[0] == 112384 && ['W. Used', 'W. Failed'].includes(condition)" :items="duplicateProducts" v-model="duplicateProduct" color="secondary"
                                    label="Select Product" box :style="{ width: '50%', margin: 'auto' }"></v-select>
                                
                                <v-select v-if="!computeShowSubmit" :items="allPrinters" v-model="selectedPrinter" color="secondary"
                                    label="Select Printer" box :style="{ width: '50%', margin: 'auto' }"></v-select>

                                <v-btn v-if="computeShowSubmit" color="success" @click="completeHybrid('rev')">Submit Grade</v-btn>
                                <v-btn v-if="!computeShowSubmit" color="success" @click="printRevShareLabel()">Print Label</v-btn>
                                <v-btn v-if="!foundProduct[0].x_require_model" color="primary" @click="reset()">Go Home</v-btn>
                            </div>

                            <div v-if="asurionView">
                                <h2 class="my-2">Confirm this is Asurion?</h2>
                                <v-btn color="success" @click="completeHybrid('asurion')">Yes - Asurion</v-btn>
                                <!-- <v-btn color="error" @click="servicesView = false; revshareView = false; asurionView = false;">No - Not Asurion</v-btn> -->
                                
                            </div>
                            <v-btn @click="servicesView = false; revshareView = false; asurionView = false;">Go Back</v-btn>
                            
                        </v-card>
                    </v-card>
                </div>



                <!-- FAILED REPAIR -->
                
                <div v-else-if="repair[0].x_mrp_passed === 'FAILED' && ![OWNER.BB, OWNER.ASN].includes(repair[0].partner_id[0])">
                    <v-card color="primary" class="mb-5 elevation-0" :style="{ textAlign: 'center' }">
                        <h2 class="mt-2">This watch has a failed step!</h2>
                        <v-btn color="primary" @click="reset()">Go Home</v-btn>
                    </v-card>
                </div>

                <div v-else-if="repair[0].x_mrp_passed === 'FAILED' && [OWNER.BB].includes(repair[0].partner_id[0])">
                    <v-card color="primary" class="mb-5 elevation-0" :style="{ textAlign: 'center' }">
                        <h2 class="mt-2"> Failed!</h2>
                        <v-layout justify-center>
                            <div>
                                <h1 class="mb-3">LCD Grade</h1>
                                <div class="grade-circle" :style="{ color: lcdGrade.color }">
                                    {{ lcdGrade.text }}
                                </div>
                            </div>
                            <div>
                                <h1 class="mb-3">Housing Grade</h1>
                                <div class="grade-circle mx-5" :style="{ color: housingGrade.color }">
                                    {{ housingGrade.text }}
                                </div>
                            </div>
                        </v-layout>
                        <v-btn color="primary" @click.native="submitRepair(false)">Submit Grade</v-btn>
                        <v-btn color="primary" @click="reset()">Go Home</v-btn>
                    </v-card>
                </div>


                <div v-else-if="repairState === 'draft' && repair[0].partner_id[0] == OWNER.BB">
                    <v-card color="primary" class="mb-5 elevation-0" :style="{ textAlign: 'center' }">
                        <v-card height="620px" class="mt-2" color="primary" flat>
                                <h2 class="my-2">Select A Grade</h2>
                                <v-select color="secondary" :items="possibleGrades" item-text="text"
                                    return-object v-model="bbGrade" label="Select A Grade"
                                    box :style="{ width: '50%', margin: 'auto' }"></v-select>
                                <v-btn color="primary" @click.native="submitRepair(false)">Submit Grade</v-btn>
                        </v-card>
                    </v-card>
                </div>

                <div v-else-if="repairState === 'draft' && repair[0].partner_id[0] == OWNER.ASN">
                    <v-card color="primary" class="mb-5 elevation-0" :style="{ textAlign: 'center' }">
                        <h2 class="my-2">Select A Grade</h2>
                        <v-layout row wrap justify-center>
                            <v-flex xs10 md6>
                                <v-select color="secondary" :items="asnGrades" item-text="text"
                                    return-object v-model="asnGrade" label="Select A Grade"
                                    box></v-select>
                            </v-flex>
                        </v-layout>
                        
                        <!-- <v-btn color="secondary" v-if="originalState !== 'under_repair'"
                            @click.native="submitRepair(true)">Send to
                            Polishing</v-btn> -->
                        <v-btn color="primary" @click.native="submitRepair(false)">Submit Grade</v-btn>
                    </v-card>
                </div>

                <div v-else-if="repairState === 'under_repair'">
                    <v-card color="primary" class="mb-5 elevation-0" height="550px" :style="{ textAlign: 'center' }">
                        <h2 class="mt-5">Was this product polished?</h2>
                        <v-btn color="success" @click="repairState = 'draft'">Yes</v-btn>
                        <v-btn color="error" @click="repairState = 'draft'">No</v-btn>
                    </v-card>
                </div>
            </v-card>
        </v-flex>
        
        
        <!-- GRADE HISTORY -->
        <v-dialog v-model="gradeHistoryDialog" :width="dialogWidth">
            <v-card color="primary">
                <v-card-title>
                    <h2>Grade History</h2>
                </v-card-title>
                <v-card-text>
                    <v-data-table flat :headers="gradeDataHeaders" :pagination="gradeDataPagination"
                        class="primary mx-2" :items="gradeHistory">
                        <template v-slot:items="props">
                            <td class="text-xs-left">{{ localizeDate(props.item.evalDate, true) }}</td>
                            <td class="text-xs-left">
                                {{ props.item.evalBy }}
                            </td>
                            <td class="text-xs-left">
                                {{ props.item.housingGrade }}
                            </td>
                            <td class="text-xs-left">
                                {{ props.item.lcdGrade }}
                            </td>
                        </template>
                    </v-data-table>
                </v-card-text>
                <v-card-actions>

                    <v-btn @click="gradeHistoryDialog = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LoginCheck from "@/mixins/LoginCheck";
import Common from "@/mixins/Common";

export default {
    name: "watch-bb",
    mixins: [LoginCheck, Common],

    data() {
        return {
            OWNER: {
                VERIZON: 98,
                ASN: 2878449,
                BB: 2391341,
                VICTRA: 3679910
            },
            currentStep: 1,
            repairState: false,
            grades: [],
            showRevShare: false,
            notRevShare: false,
            surfaces: [
                {
                    surface: "Grade",
                    surfaceCode: "LCD",
                },
                { surface: "", surfaceCode: false },
            ],
            report: false,
            gradeHistoryDialog: false,

            asurionView: false,
            revshareView: false,
            servicesView: false,


            gradeDataHeaders: [{ text: "Grade Date", value: "evalDate" },
            { text: "Graded By", value: "evalBy" },
            { text: "Housing Grade", value: "housingGrade" },
            { text: "LCD Grade", value: "lcdGrade" }],
            gradeDataPagination: {
                rowsPerPage: 10,
                sortBy: "evalDate",
                descending: true,
                page: 1
            },
            originalState: false,
            condition: false,
            asnGrade: false,
            bbGrade: false,
            asnGrades: [
                {text: 'BLB', value: 'BLB'},
                {text: 'DNC', value: 'DNC'},
                // {text: 'DND', value: 'DND'},
                // {text: 'HRP', value: 'HRP'},
                {text: 'WME', value: 'WME'},  
            ],
            duplicateProduct: false,
            duplicateProducts: [
                {
                    text: "Apple Watch SE",
                    value: "SE1"
                },
                {
                    text: "Apple Watch SE2",
                    value: "SE2"
                }
            ],
            model: false,
            partner: false,
        };
    },
    computed: {
        ...mapGetters({
            repair: "repair/getRepair",
            repairOperations: "repair/getRepairOperations",
            possibleGrades: "repair/getGrades",
            storedPrinter: "repair/getSelectedPrinter",
            storedPrinterTwo: "repair/getSelectedPrinterTwo",
            allPrinters: "repair/getAllPrinters",
            user: "app/getUser",
            gradeHistory: "repair/getGradeHistory",
            foundProduct: "product/getProduct",
            foundLot: "stockLot/getLot",
            storedPrintSize: "repair/getStoredPrintSize",
            storedPrintSizeTwo: "repair/getStoredPrintSizeTwo"

        }),
        hasBeenTested() {
            let testingStep = this.repairOperations.filter(
                (item) => item.product_id[0] == 743
            );
            if (testingStep.length > 0) {
                return true;
            } else {
                return false;
            }
        },
        selectedPrinter: {
            get() {
                return this.storedPrinter;
            },
            set(val) {
                return this.$store.commit("repair/setSelectedPrinter", val);
            },
        },
        selectedPrinterTwo: {
            get() {
                return this.storedPrinterTwo;
            },
            set(val) {
                return this.$store.commit("repair/setSelectedPrinterTwo", val);
            },
        },

        canBePolished() {
            return (
                this.housingGrade.value > this.lcdGrade.value &&
                this.repair[0].state !== "under_repair" &&
                this.housingGrade.value > 79
            );
        },

        canBeAsurion() {
            if (!this.foundLot) return false;
            if (!this.foundLot[0]) return false;
            else if (!this.foundLot[0].x_vendor_ref) return false;
            else if (this.foundLot[0].x_vendor_ref.startsWith('NVZ')) return false;
            else return true;
        },

        selectedSize: {
            get() {
                return this.storedPrintSize;
            },
            set(val) {
                return this.$store.commit("repair/setStoredPrintSize", val);
            },
        },

        selectedSizeTwo: {
            get() {
                return this.storedPrintSizeTwo;
            },
            set(val) {
                console.log("setting size two to ", val)
                return this.$store.commit("repair/setStoredPrintSizeTwo", val);
            },
        },

        housingGrade() {
            if (this.asnGrade) {
                return {
                    text: this.asnGrade.value,
                    color: "green",
                    value: 100
                }
            }

            if (this.bbGrade) {
                return this.possibleGrades.filter(
                    (grade) => grade.text === this.bbGrade.text
                )[0];
            }


            return this.grades[1] || {
                text: 'A',
                color: 'green',
                value: 100
            };
        },

        lcdGrade() {
            if (this.asnGrade) {
                return {
                    text: this.asnGrade.value,
                    color: "green",
                    value: 100
                }
            }

            if (this.bbGrade) {
                return this.possibleGrades.filter(
                    (grade) => grade.text === this.bbGrade.text
                )[0];
            }
            return this.grades[0] || {
                text: 'A',
                color: 'green',
                value: 100
            };
        },

        finalGrade() {
            if (this.asnGrade) {
                return this.housingGrade
            }

            if (this.bbGrade) {
                return this.bbGrade
            }
            return this.lcdGrade.value >= this.housingGrade.value
                ? this.housingGrade
                : this.lcdGrade;
        },

        dialogWidth() {
            if (this.$vuetify.breakpoint.xs) {
                return "100%";
            } else if (this.$vuetify.breakpoint.sm) {
                return "55%";
            }
            return "55%";
        },

        computeShowSubmit() {
            const requireModel = this.foundProduct[0].x_require_model;
            const appleWatch = this.repair[0].product_id[1].startsWith('[APLS');
            if (requireModel) return true;
            else if (requireModel && !appleWatch && ['W. Used', 'W. Failed'].includes(this.condition)) return true;
            else return false;
        }

    },
    async beforeMount() {
        if (!this.repair.length || this.repair[0].name !== this.$route.params.id) {
            await this.searchServices({ serial: this.$route.params.id });
        }
        await this.getAllPrinters();
        await this.getOperation({ id: this.repair[0].id });
        this.partner = await this.getPartner({ po: this.repair[0].x_origin });
        if (this.repair.length) {
            this.repairState = this.repair[0].state;
            this.originalState = this.repair[0].state;
        } else {
            this.reset();
        }

        this.report = {
            repairID: this.repair[0].id,
            serial: this.repair[0].name,
            housingGrade: false,
            lcdGrade: false,
            rawProduct: {
                id: this.repair[0].product_id[0],
                product: this.repair[0].product_id[1],
            },
        };

        this.model = this.repair[0].x_model_number ? this.repair[0].x_model_number : "";

        if (this.repair[0].x_mrp_passed === 'FAILED' && [this.OWNER.BB].includes(this.repair[0].partner_id[0])) {
            this.grades = [
                {
                    text: "D+", value: 60, color: "red"
                },
                {
                    text: "D+", value: 60, color: "red"
                }
            ];
        } else if (this.repair[0].x_mrp_passed === 'FAILED' && [this.OWNER.ASN].includes(this.repair[0].partner_id[0])) {
            this.asnGrades = [{text: 'DND', value: 'DND'},
            {text: 'HRP', value: 'HRP'}, {text: 'WME', value: 'WME'}]
        }
    },

    methods: {
        ...mapActions({
            searchServices: "repair/searchServices",
            sendToPolishing: "repair/sendToPolishing",
            submitGradeToOdoo: "repair/submitGrade",
            completeWatchRepair: "repair/completeWatchRepair",
            getAllPrinters: "repair/getAllPrinters",
            printVZDLabel: "repair/printVZDLabel",
            printSortLabel: "repair/printSortLabel",
            printCustomLabel: "repair/printCustomLabel",
            printBBKitLabel: "repair/printBBKitLabel",
            printKitLabel: "repair/printKitLabel",
            printAsnLabel: "repair/printAsnLabel",
            printAsurionLabel: "repair/printAsurionLabel",
            productSearch: "product/searchOdoo",
            productSearch2: "product/search",
            reportGrade: "repair/reportGrade",
            getOperation: "repair/getRepairOperations",
            getGradehistory: "repair/fetchGradeHistory",
            addOperation: "repair/addOperation",
            getLot: "stockLot/search",
            printProductLabel: "repair/printProductLabel",
            getAsurionPO: "repair/getAsurionPO",
            repairUpdate: "repair/updateRepair",
            getPartner: "repair/getPartner"
        }),
        
        async updateModel() {
            if (!this.model) {
                this.$store.dispatch("app/setSnackbar", {
                    text: "Please enter a model number",
                    color: "red",
                });
                return;
            }
            await this.repairUpdate({
                body: {
                    id: this.repair[0].id,
                    x_model_number: this.model
                }
            });
        
            this.$store.dispatch("app/setSnackbar", {
                text: "Model number updated",
                color: "green",
            });
            await this.searchServices({ serial: this.$route.params.id });
        
        },
        async notPolished() {
            const res = await this.completeWatchRepair({
                id: this.repair[0].id,
                housing_grade: "",
                lcd_grade: "",
                final_grade: "",
                polished: false,
            });
            if (res.success) {
                this.$store.dispatch("app/setSnackbar", {
                    text: "Repair complete!",
                    color: "green",
                });
                this.repairState = "done";
            } else {
                this.$store.dispatch("app/setSnackbar", {
                    text: res.message,
                    color: "red",
                });
            }
        },

        async polishRevShare() {
            await this.submitGradeToOdoo({
                grade: {
                    grade_name: "Housing Grade",
                    grade_result: this.housingGrade.text,
                    grade_value: this.housingGrade.value,
                    repair_id: this.repair[0].id,
                    is_final: false,
                }
            });
            this.$store.dispatch("app/setSnackbar", {
                text: "Sent to Polishing!",
                color: "green",
            });

            this.reset();
        },

        async completeHybrid(type) {
            if (type === 'vz') {
                this.submitRepair(false);
            }
            else if (type === 'rev') {
                if (this.repair[0].product_id[0] ==  112384 && ['W. Used', 'W. Failed'].includes(this.condition) && !this.duplicateProduct) {
                    this.$store.dispatch("app/setSnackbar", {
                        text: "Please Select a Product!",
                        color: "red",
                    });
                    return;
                }

                await this.addOperation({
                    repairID: this.repair[0].id,
                    step: "Grading"
                });

                const res = await this.completeWatchRepair({
                    id: this.repair[0].id,
                    condition: this.condition,
                    polished: false,
                    x_legacy_sku: this.duplicateProduct || false
                });
                if (res.success) {
                    this.$store.dispatch("app/setSnackbar", {
                        text: "Grade Submitted!",
                        color: "green",
                    });
                    this.repairState = "done";
                } else {
                    this.$store.dispatch("app/setSnackbar", {
                        text: res.message,
                        color: "red",
                    });
                }
            }
            else if (type === 'asurion') {
                await this.addOperation({
                    repairID: this.repair[0].id,
                    step: "Grading"
                });
                const res = await this.completeWatchRepair({
                    id: this.repair[0].id,
                    condition: 'asurion',
                    polished: false,
                });
                if (res.success) {
                    this.$store.dispatch("app/setSnackbar", {
                        text: "Grade Submitted!",
                        color: "green",
                    });
                    this.repairState = "done";
                } else {
                    this.$store.dispatch("app/setSnackbar", {
                        text: res.message,
                        color: "red",
                    });
                }
            }

            await this.searchServices({ serial: this.$route.params.id });
        },

        async handleVZview(view) {
            if (view === 'services') {
                this.servicesView = true;
            }
            else if (view === 'revshare') {
                await this.productSearch2({
                    body: {
                        kwargs: {
                            product: false,
                            id: this.repair[0].product_id[0]
                        }
                    }
                });
                this.revshareView = true;
            }
            else if (view === 'asurion') {
                this.asurionView = true;
            }
        },

        async printRevShareLabel() {
            if (!this.selectedPrinter) {
                this.$store.dispatch("app/setSnackbar", {
                    text: "Please Select a Printer!",
                    color: "red",
                });
            }
            else if (!this.condition) {
                this.$store.dispatch("app/setSnackbar", {
                    text: "Please Select a Condition!",
                    color: "red",
                });
            } else {

                const success = await this.printCustomLabel({
                    text: this.condition,
                    printer: this.selectedPrinter,
                });
                if (success) {
                    await this.addOperation({
                        repairID: this.repair[0].id,
                        step: "Grading"
                    });
                    this.$store.dispatch("app/setSnackbar", {
                        text: "Label(s) printed to " + this.selectedPrinter,
                        color: "green",
                    });
                } else {
                    this.$store.dispatch("app/setSnackbar", {
                        text: res.message,
                        color: "red",
                    });
                }
            }
        },

        async printLabel(two = false) {
            if (!this.selectedPrinter) {
                this.$store.dispatch("app/setSnackbar", {
                    text: "Please Select a Printer!",
                    color: "red",
                });
            } else {
                await this.searchServices({ serial: this.$route.params.id });
                await this.productSearch([
                    {
                        field: "id",
                        operator: "=",
                        value: this.repair[0].x_finished_product[0],
                    }
                ]);
                if (this.foundProduct[0].manufacturer_id[0] == 2526791) {
                    // let po = await this.getAsurionPO();
                    // if (!po.success) {
                    //     this.$store.dispatch("app/setSnackbar", {
                    //         text: po.message,
                    //         color: "red",
                    //     });
                    //     return;
                    // }
                    // await this.printAsurionLabel({
                    //     printer: this.selectedPrinter,
                    //     imei: this.repair[0].x_imei,
                    //     sku: this.foundProduct[0].default_code,
                    //     po: 'DWCF1347869'
                    // })
                    // await this.printProductLabel({
                    //     printer: this.selectedPrinter,
                    //     sn: this.repair[0].name,
                    //     sku: this.foundProduct[0].default_code,
                    //     barcode: this.foundProduct[0].barcode,
                    //     description: this.foundProduct[0].x_sales_description || this.foundProduct[0].display_name,
                    //     owner: this.foundProduct[0].hs_code || this.repair[0].x_customer_code,
                    //     size: 'small'
                    // });

                    await this.printProductLabel({
                        printer: two ? this.selectedPrinterTwo : this.selectedPrinter,
                        sn: this.repair[0].name,
                        sku: this.foundProduct[0].default_code,
                        barcode: this.foundProduct[0].barcode,
                        description: this.foundProduct[0].x_sales_description || this.foundProduct[0].display_name,
                        owner: this.foundProduct[0].hs_code || this.repair[0].x_customer_code,
                        size: two ? this.storedPrintSizeTwo : this.selectedSize
                    });
                    

                    return;
                }
                if (this.foundProduct[0].default_code.startsWith('OCP')) {
                    await this.printVZDLabel({
                        printer: two ? this.selectedPrinterTwo : this.selectedPrinter,
                        sku: this.foundProduct[0].default_code,
                        serial: this.repair[0].name,
                        barcode: this.foundProduct[0].barcode,
                        desc: this.foundProduct[0].x_sales_description || this.foundProduct[0].display_name,
                    });
                    return;
                }

                if (this.repair[0].partner_id[0] == this.OWNER.BB) {
                    await this.printSortLabel({
                        repair_id: this.repair[0].id,
                        printer: two ? this.selectedPrinterTwo : this.selectedPrinter,
                    });
                    await this.printBBKitLabel({
                        printer: two ? this.selectedPrinterTwo : this.selectedPrinter,
                        sku: this.foundProduct[0].default_code,
                        upc: this.foundProduct[0].x_upc,
                        desc: this.foundProduct[0].x_sales_description,
                    });
                }
                else if (this.repair[0].partner_id[0] == this.OWNER.ASN) {
                    await this.printAsnLabel({
                        printer: two ? this.selectedPrinterTwo : this.selectedPrinter,
                        sku: this.foundProduct[0].default_code,
                        serial: this.repair[0].name,
                        sort: this.foundProduct[0].hs_code || "",
                        model: this.repair[0].x_model_number || null
                    })
                    await this.printAsnLabel({
                        printer: two ? this.selectedPrinterTwo : this.selectedPrinter,
                        sku: this.foundProduct[0].default_code,
                        serial: this.repair[0].name,
                        sort: this.foundProduct[0].hs_code || "",
                        model: this.repair[0].x_model_number || null
                    })
                } else {
                    // if (["W. Used", "W. Failed"].includes(this.foundProduct[0].x_vendor_sku) )  {
                        await this.printProductLabel({
                            printer: two ? this.selectedPrinterTwo : this.selectedPrinter,
                            sn: this.repair[0].name,
                            sku: this.foundProduct[0].default_code,
                            barcode: this.foundProduct[0].barcode,
                            description: this.foundProduct[0].x_sales_description || this.foundProduct[0].display_name,
                            owner: this.foundProduct[0].hs_code || this.repair[0].x_customer_code,
                            size: two ? this.storedPrintSizeTwo : this.selectedSize
                        });
                    // } else {
                    //     await this.printAsnLabel({
                    //         printer: this.selectedPrinter,
                    //         sku: this.foundProduct[0].default_code,
                    //         serial: this.repair[0].name,
                    //         sort: this.foundProduct[0].hs_code || "",
                    //         model: "Print Large Label"
                    //     })
                    // }
                }
            }
        },

        async openGradeHistory() {
            await this.getGradehistory({ repairID: this.repair[0].id })
            this.gradeHistoryDialog = true;
        },

        async submitRepair(polish) {
            let id = this.repair[0].id;
            let grades = [
                {
                    grade_name: "Housing Grade",
                    grade_result: this.housingGrade.text,
                    grade_value: this.housingGrade.value,
                    repair_id: id,
                    is_final: false,
                },
                {
                    grade_name: "LCD Grade",
                    grade_result: this.lcdGrade.text,
                    grade_value: this.lcdGrade.value,
                    repair_id: id,
                    is_final: false,
                },
            ];

            if (polish) {
                const res = await this.sendToPolishing({
                    id,
                    housing_grade: this.housingGrade.text,
                    lcd_grade: this.lcdGrade.text,
                    polished: true,
                });
                if (res.success) {
                    this.sendReport();
                    this.storeGrade(grades, "Product is ready for polishing");
                    this.reset();
                } else {
                    this.$store.dispatch("app/setSnackbar", {
                        text: res.message,
                        color: "red",
                    });
                }
            } else {
                const res = await this.completeWatchRepair({
                    id,
                    housing_grade: this.housingGrade.text,
                    lcd_grade: this.lcdGrade.text,
                    final_grade: this.finalGrade.text,
                    polished: false,
                });
                if (res.success) {
                    this.sendReport();
                    grades[0].is_final = true;
                    grades[1].is_final = true;
                    await this.addOperation({
                        repairID: id,
                        step: "Grading"
                    });
                    this.storeGrade(grades, "Final sku assigned!");
                    this.repairState = "done";
                } else {
                    this.$store.dispatch("app/setSnackbar", {
                        text: res.message,
                        color: "red",
                    });
                }
            }

            await this.searchServices({ serial: this.$route.params.id });
        },

        sendReport() {
            this.report.housingGrade = this.housingGrade.text;
            this.report.lcdGrade = this.lcdGrade.text;
            this.report.evalBy = this.user.displayName;
            this.reportGrade(this.report);
        },

        async storeGrade(grades, message) {
            grades.forEach(async grade => {
                await this.submitGradeToOdoo({ grade });
            });
            await this.$store.dispatch("app/setSnackbar", {
                text: message,
                color: "green",
            });
        },

        reset() {
            this.$store.commit("repair/setRepair", []);
            this.currentStep = 1;
            this.$router.push("/watch-grading-bb");
        },

        disableButton(index) {
            if (this.grades[index] && this.grades[index + 1]) {
                return false;
            } else {
                return true;
            }
        }
    }
};
</script>

<style>
.grade-circle {
    width: 400px;
    height: 400px;
    border-radius: 50%;
    font-size: 90px;
    line-height: 400px;
    text-align: center;
    border: 1px solid;
}
</style>